/**
 * ARIA Frontend Main Entry Point
 * Version: 1.0.0
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { MsalProvider } from '@azure/msal-react';

import App from './App';
import { store } from './store';
import { apolloClient } from './config/apollo';
import { msalInstance } from './config/msal';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <ApolloProvider client={apolloClient}>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </ApolloProvider>
    </MsalProvider>
  </React.StrictMode>
);
